module.exports = __webpack_public_path__ + "img/zotero.88f34e88.png";